module.exports = __webpack_public_path__ + "static/media/need-travel-coverage.24711b81.jpg";